import React, { useCallback } from 'react';
import { useAtom, useAtomValue } from '@exodus/headless-ui';
import AssetInput from '../input/index.js';
import { INPUT_MODE } from '../../constants.js';
import { fromAmountAtom, fromAssetAtom, fromFiatAmountAtom, isFromLoadingAtom, } from '../../../atoms/index.js';
import useDeferLoading from '../../hooks/use-defer-loading.js';
const FromAssetInput = ({ Component, className, style, mode = INPUT_MODE.CRYPTO, onFocus, onBlur, debounceMs }, ref) => {
    const fromAsset = useAtomValue(fromAssetAtom);
    const [fromAmount, setFromAmount] = useAtom(fromAmountAtom);
    const [fromFiatAmount, setFromFiatAmount] = useAtom(fromFiatAmountAtom);
    const isLoading = useAtomValue(isFromLoadingAtom);
    const resetAmount = useCallback(() => setFromAmount(undefined), [setFromAmount]);
    return (React.createElement(AssetInput, { ref: ref, Component: Component, className: className, style: style, mode: mode, direction: "from", asset: fromAsset, amount: fromAmount, loading: useDeferLoading(isLoading), fiatAmount: fromFiatAmount, setFiatAmount: setFromFiatAmount, setAmount: setFromAmount, resetAmount: resetAmount, onFocus: onFocus, onBlur: onBlur, debounceMs: debounceMs }));
};
export default React.forwardRef(FromAssetInput);
